import { useMemo } from 'react';
import type { FormatRef, RaceTypeRef } from '@/api/referenceService';
import { useFormats, useRaceTypes } from './useReference';

export interface FormatGroup {
  raceType: RaceTypeRef;
  formats: FormatRef[];
}

/** v7: formats under their race type, both in reference order; a type without formats is left out. */
export const groupFormatsByRaceType = (raceTypes: RaceTypeRef[], formats: FormatRef[]): FormatGroup[] =>
  raceTypes
    .map((raceType) => ({ raceType, formats: formats.filter((f) => f.raceTypeId === raceType.id) }))
    .filter((g) => g.formats.length > 0);

export const useFormatGroups = (): FormatGroup[] => {
  const { data: formats = [] } = useFormats();
  const { data: raceTypes = [] } = useRaceTypes();
  return useMemo(() => groupFormatsByRaceType(raceTypes, formats), [raceTypes, formats]);
};
